export default "__VITE_ASSET__9Z0UcQ39__"